module.exports = __webpack_public_path__ + "img/5.eb61027b.webp";